import { MOCKED_PRODUCTS } from 'constants/products/upsell';

export const getProduct = (productCode?: keyof typeof MOCKED_PRODUCTS | '') => {
    if (!productCode || !Object.hasOwn(MOCKED_PRODUCTS, productCode)) {
        return null;
    }

    return MOCKED_PRODUCTS[productCode];
};
